import classNames from 'classnames';
import React from 'react';
import { Image as ImageRender } from '../../platformui';
import LinkButton from '../../platformui/Buttons/LinkButton';

const SupportPlaceBlock = (props) => {
  const {
    Button,
    Image,
    Name,
    DescriptionText,
    EmailAddress,
    PhoneNumber,
    ChatAddressLink,
    ChatAddressLinkText,
    WebAddressLink,
    WebAddressLinkText,
    ActiveFilters,
    isArticlePage,
    isFirstItem,
  } = props;

  const isExternalChat = !ChatAddressLink?.includes('umo');
  const isExternalWebAddress = !WebAddressLink?.includes('umo');

  return (
    <div className="c-contact-place-card">
      <div
        className={classNames({
          'c-contact-place-card__container': true,
          'c-contact-place-card__container--article-page': isArticlePage,
          'c-contact-place-card__container--first-item': isFirstItem,
        })}
      >
        <div className="c-contact-place-card__container__desktop-logo">
          {Image &&
            Image.map((img, index) => {
              return (
                <ImageRender
                  className="c-contact-place-card__container__desktop-logo__img-frame"
                  key={index}
                  ImageUrl={img.ImageSrc}
                  Description={img.ImageDescription}
                />
              );
            })}
        </div>

        <div className="c-contact-place-card__container__description">
          <div className="c-contact-place-card__container__description__header">
            <span className="c-contact-place-card__container__description__header__mobile-logo">
              {Image &&
                Image.map((img, index) => {
                  return (
                    <ImageRender
                      className="c-contact-place-card__container__desktop-logo__img-frame"
                      key={index}
                      ImageUrl={img.ImageSrc}
                      Description={img.ImageDescription}
                    />
                  );
                })}
            </span>
            <h3>{Name}</h3>
          </div>
          <p className="c-contact-place-card__container__description__text">
            {DescriptionText}
          </p>
          {Button && Button[0] ? (
            <div className="c-contact-place-card__container__description__footer">
              <div className="c-contact-place-card__container__description__footer__cta-container">
                <LinkButton
                  link={Button[0].ButtonLink}
                  linkText={Button[0].ButtonText}
                  buttonClass={`c-contact-place-card__container__description__footer__cta-container__${Button[0].ButtonStyling}`}
                />
              </div>
            </div>
          ) : (
            <div className="c-contact-place-card__container__description__footer">
              {EmailAddress && (
                <div className="c-contact-place-card__container__description__footer__link-container">
                  <span className="c-contact-place-card__container__description__footer__link-container__email-icon" />
                  <LinkButton
                    link={'mailto:' + EmailAddress}
                    linkText={EmailAddress}
                    altLinkText="Mailaddress"
                    buttonClass="c-contact-place-card__container__description__footer__link-container__a-link"
                  />
                </div>
              )}
              {PhoneNumber && (
                <div className="c-contact-place-card__container__description__footer__link-container">
                  <span className="c-contact-place-card__container__description__footer__link-container__phone-icon" />
                  <LinkButton
                    link={'tel:' + PhoneNumber}
                    linkText={PhoneNumber}
                    altLinkText="Telefonnummer"
                    buttonClass="c-contact-place-card__container__description__footer__link-container__phone-number"
                  />
                </div>
              )}
              {ChatAddressLink && (
                <div className="c-contact-place-card__container__description__footer__link-container">
                  <span className="c-contact-place-card__container__description__footer__link-container__chat-bubble-icon" />
                  <LinkButton
                    link={ChatAddressLink}
                    linkText={ChatAddressLinkText}
                    altLinkText="Länk till chatt"
                    buttonClass="c-contact-place-card__container__description__footer__link-container__a-link"
                  />
                  {isExternalChat && (
                    <span className="c-contact-place-card__container__description__footer__link-container__arrow-icon"></span>
                  )}
                </div>
              )}
              {WebAddressLink && (
                <div className="c-contact-place-card__container__description__footer__link-container">
                  <span className="c-contact-place-card__container__description__footer__link-container__globe-icon"></span>
                  <LinkButton
                    link={WebAddressLink}
                    linkText={WebAddressLinkText}
                    altLinkText="Länk till webbplats"
                    buttonClass="c-contact-place-card__container__description__footer__link-container__a-link"
                  />
                  {isExternalWebAddress && (
                    <span className="c-contact-place-card__container__description__footer__link-container__arrow-icon"></span>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        {!isArticlePage && (
          <div className="c-contact-place-card__container__filters">
            <ul>
              {ActiveFilters &&
                ActiveFilters.filter(
                  (filter) => filter.ShowOnContactCard === true
                ).map((filter, index) => {
                  return (
                    <li key={index}>
                      <ImageRender
                        ariaHidden={true}
                        ImageUrl={filter.ImagePath}
                        Description={filter.Description}
                      />
                      <p className="c-contact-place-card__container__filters__description">
                        {filter.Description}
                      </p>
                    </li>
                  );
                })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default SupportPlaceBlock;
